import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import clsx from 'clsx';

import css from './UserLink.module.css';

import { UserAvatar } from 'v2/components/userAvatar/UserAvatar';
import { Nullable } from 'v2/types';

interface UserLinkProps {
  userId: string;
  nickname: string;
  imgUrl?: Nullable<string>;
  extra?: ReactNode;
  highlighted?: boolean;
}

export const UserLink: FC<UserLinkProps> = ({ userId, nickname, imgUrl, extra, highlighted }) => (
  <Link to={`/user-profile/${userId}`} className={clsx(css.userLink, highlighted && css.highlighted)}>
    <UserAvatar imageUrl={imgUrl} />

    <span className={css.nickname}>{nickname}</span>

    {extra}
  </Link>
);
